import { render } from "./AgentItemsTable.vue?vue&type=template&id=23302a08&scoped=true"
import script from "./AgentItemsTable.vue?vue&type=script&lang=js"
export * from "./AgentItemsTable.vue?vue&type=script&lang=js"

import "./AgentItemsTable.vue?vue&type=style&index=0&id=23302a08&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23302a08"]])

export default __exports__